import { OrganiserCompanyToOrganiserRole } from "@evennt-tech/api-v2-core/dist/organiser-company/enums";
import useOrganiser from "./useOrganiser";

const useIsOrganiserCompanyAdmin = (): boolean => {
  const [organiser] = useOrganiser();

  return (
    organiser?.organiserCompanyToOrganisers?.[0]?.role ===
    OrganiserCompanyToOrganiserRole.ADMIN
  );
};

export default useIsOrganiserCompanyAdmin;
